import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";

export default function CancelPage() {
  return (
    <main className="pt-28 pb-24 min-h-[70vh] flex items-center" data-testid="cancel-page">
      <div className="max-w-md mx-auto px-5 text-center">
        <Reveal className="card-soft p-10">
          <h1 className="font-display text-3xl font-medium mb-3">Kauf abgebrochen</h1>
          <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed mb-8">
            Kein Problem – die Lernwelt wartet auf dich. Du kannst den Kauf jederzeit fortsetzen.
          </p>
          <div className="flex flex-col gap-3">
            <Link to="/lernwelten/farben" className="btn-primary" data-testid="cancel-back-to-product">
              Zurück zum Lernpaket
            </Link>
            <Link to="/" className="btn-ghost">Zur Startseite</Link>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
